import React from 'react'
import cn from 'classnames'
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'
import Icon from '../icon'
import './index.less'
const empty = () => {}

export interface TntdSecondPageProps {
  title?: string | React.ReactNode
  header?: React.ReactNode
  toolBar?: React.ReactNode
  footer?: React.ReactNode
  visible?: boolean
  destroyOnClose?: boolean
  onBack?: () => void
  mode?: 'default' | 'absolute' | 'fixed'
  inTab?: boolean
  className?: string
  children?: React.ReactNode
}

export default function TntdSecondPage({
  title,
  header,
  toolBar = null,
  footer,
  visible,
  destroyOnClose,
  onBack = empty,
  mode = 'default',
  inTab = false,
  children,
  className,
}: TntdSecondPageProps): React.ReactElement | null {
  if (!visible && destroyOnClose) {
    return null
  }

  return (
    <LocaleReceiver componentName="TntdSecondPage">
      {(locale) => {
        return (
          <div
            className={cn('tntd-second-page', className, {
              'tntd-second-page-intab': inTab,
              'tntd-second-page-absolute': mode === 'absolute',
              'tntd-second-page-fixed': mode === 'fixed',
              'tntd-second-page-hidden': !visible,
            })}
          >
            <div className="tntd-second-page-header">
              {header ? (
                header
              ) : (
                <>
                  <a className="tntd-second-page-header-back" onClick={onBack}>
                    <Icon type="left" />
                    {(locale as Record<'back', object>).back}
                  </a>
                  <span className="tntd-second-page-header-title">{title}</span>
                  <div className="tntd-second-page-header-toolbar">{toolBar}</div>
                </>
              )}
            </div>
            <div className="tntd-second-page-body">
              <div className="tntd-second-page-inner">{children}</div>
            </div>
            {footer && <div className="tntd-second-page-footer">{footer}</div>}
          </div>
        )
      }}
    </LocaleReceiver>
  )
}
